const DELETION_ACTION_TYPES = {
  DELETE: "DELETE_PARTICIPANT",
  DELETE_REQUEST: "DELETE_PARTICIPANT_REQUEST",
  DELETE_SUCCESS: "DELETE_PARTICIPANT_SUCCESS",
  DELETE_FAILURE: "DELETE_PARTICIPANT_FAILURE",
}

export default DELETION_ACTION_TYPES
